import { Text } from '@chakra-ui/react'
import { capitalize } from 'lodash'
import React from 'react'
import { AccountDetails } from '../../../../types'

interface CloseAccountDescriptionProps {
  accountDetails: AccountDetails
}

const CloseAccountDescription = ({
  accountDetails: { accountNumber, accountType, accountTitle },
}: CloseAccountDescriptionProps) => (
  <Text
    fontWeight="semibold"
    data-testid="close-account-description"
  >{`${accountNumber} (${accountType}) ${
    accountTitle ? accountTitle.split(' ').map(capitalize).join(' ') : ''
  }`}</Text>
)

export default CloseAccountDescription
